export const tabs = {
  colorScheme: {
    light: {
      tablist: {
        background: '{surface.0}',
      },
      tab: {
        color: '{surface.800}',
        hoverColor: '{surface.950}',
        activeColor: '{primary.color}',
      },
      tabpanel: {
        background: '{surface.0}',
      },
    },
    dark: {
      tablist: {
        background: '#3c434f',
        borderColor: '#5B5F69',
      },
      tab: {
        color: '{surface.200}',
        hoverColor: 'white',
        activeColor: 'white',
        borderColor: '#5B5F69',
        hoverBorderColor: '#5B5F69',
      },
      tabpanel: {
        background: '#3c434f',
        color: 'white',
      },
      navButton: {
        background: '#3c434f',
        color: 'white',
      },
    },
  },
};
